'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Utility = require('../../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _CartStore = require('../../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _MainStore = require('../../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _ScheduleScreenStore = require('../../../stores/ScheduleScreenStore');

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _takeAway = require('../../../../img/take-away.png');

var _takeAway2 = _interopRequireDefault(_takeAway);

var _motorbike = require('../../../../img/motorbike.png');

var _motorbike2 = _interopRequireDefault(_motorbike);

var _dinein_new = require('../../../../img/dinein_new.png');

var _dinein_new2 = _interopRequireDefault(_dinein_new);

var _Constants = require('../../Constants');

var Constants = _interopRequireWildcard(_Constants);

var _reactRouterDom = require('react-router-dom');

var _SpinButton = require('../../generic/SpinButton');

var _SpinButton2 = _interopRequireDefault(_SpinButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withLocationDetailReactRouter(Component) {
    function ComponentWithLocationDetailReactRouter(props) {
        // const navigate = useNavigate();
        var history = (0, _reactRouterDom.useHistory)();
        var params = (0, _reactRouterDom.useParams)();
        return _react2.default.createElement(Component, _extends({}, props, { history: history, params: params /* other hooks */ }, {
            params: params

        }));
    }
    return ComponentWithLocationDetailReactRouter;
}

var CartLocationDetail = function (_React$Component) {
    _inherits(CartLocationDetail, _React$Component);

    function CartLocationDetail(props) {
        _classCallCheck(this, CartLocationDetail);

        var _this = _possibleConstructorReturn(this, (CartLocationDetail.__proto__ || Object.getPrototypeOf(CartLocationDetail)).call(this, props));

        _this.state = {
            orderType: "",
            cartItems: "",
            location: "",
            vColor: "",
            vMakeModel: "",
            deliveryAddress: {},
            slData: "",
            isPreferCurbside: false,
            serviceLocation: ""
        };

        _this._bind('handleChange', 'getScheduleOrderDateTime', 'loadImage', 'getOrderDetailStructure', 'getOrderTypeTitle', 'onCartStoreChange', 'redirectToMainPage');
        return _this;
    }

    _createClass(CartLocationDetail, [{
        key: '_bind',
        value: function _bind() {
            var _this2 = this;

            for (var _len = arguments.length, methods = Array(_len), _key = 0; _key < _len; _key++) {
                methods[_key] = arguments[_key];
            }

            methods.forEach(function (method) {
                return _this2[method] = _this2[method].bind(_this2);
            });
        }

        // componentDidMount() {
        //
        // }

    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            var self = this;

            var cartItems = _CartStore2.default.getCartCount();
            var scheduleDateTime = _ScheduleScreenStore2.default.getScheduledDate();
            var vColor = _CartStore2.default.getOrderVehicleColor();
            var vMakeModel = _CartStore2.default.getOrderVehicleMakeModel();
            var deliveryAddressObj = _CartStore2.default.getDeliveryAddress();
            var slData = _CartStore2.default.getDineInServiceLocationData();
            var isPreferCurbside = _CartStore2.default.getIsPreferCurbsideEnabled();

            self.setState({
                cartItems: cartItems,
                orderType: _CartStore2.default.getOrderType(),
                scheduleDateTime: scheduleDateTime,
                vColor: vColor,
                vMakeModel: vMakeModel,
                deliveryAddress: deliveryAddressObj,
                slData: slData,
                isPreferCurbside: isPreferCurbside,
                serviceLocation: _CartStore2.default.getDineInServiceLocation(),
                placeHolder: self.getPlaceHolder(),
                location: this.props.location
            });

            // listen to cart store changes
            this.listenCartStore = _CartStore2.default.listen(this.onCartStoreChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.listenCartStore();
        }
    }, {
        key: 'onCartStoreChange',
        value: function onCartStoreChange() {
            this.setState({
                orderType: _CartStore2.default.getOrderType(),
                deliveryAddress: _CartStore2.default.getDeliveryAddress(),
                isPreferCurbside: _CartStore2.default.getIsPreferCurbsideEnabled()
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {

            var self = this;
            if (nextProps) {
                var orderType = _CartStore2.default.getOrderType();
                var scheduleDateTime = _ScheduleScreenStore2.default.getScheduledDate();
                var vColor = _CartStore2.default.getOrderVehicleColor();
                var vMakeModel = _CartStore2.default.getOrderVehicleMakeModel();
                var deliveryAddressStr = _CartStore2.default.getDeliveryAddress();
                var slData = _CartStore2.default.getDineInServiceLocationData();
                var isPreferCurbside = _CartStore2.default.getIsPreferCurbsideEnabled();

                this.setState({
                    orderType: orderType,
                    scheduleDateTime: scheduleDateTime,
                    vColor: vColor,
                    vMakeModel: vMakeModel,
                    deliveryAddress: deliveryAddressStr,
                    slData: slData,
                    isPreferCurbside: isPreferCurbside,
                    serviceLocation: _CartStore2.default.getDineInServiceLocation(),
                    placeHolder: self.getPlaceHolder()
                });
            }
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            e.preventDefault();
            //open schedule modal
            this.props.callBackParent(true);
        }
    }, {
        key: 'getPlaceHolder',
        value: function getPlaceHolder() {
            var self = this;
            var serviceLocation = _CartStore2.default.getDineInServiceLocationData();
            if (serviceLocation != null) {
                return "Enter " + serviceLocation;
            } else {
                return "Enter Table Number";
            }
        }
    }, {
        key: 'getScheduleOrderDateTime',
        value: function getScheduleOrderDateTime() {
            var dateStringWithTime = "";

            if (!Utils.isEmpty(this.state.scheduleDateTime)) {
                dateStringWithTime = Utils.formatTime(new Date(this.state.scheduleDateTime));
            } else {
                dateStringWithTime = "ASAP";
            }

            return dateStringWithTime;
        }
    }, {
        key: 'loadImage',
        value: function loadImage() {
            if (this.isPickup()) {
                return _takeAway2.default;
            } else if (this.isDelivery()) {
                return _motorbike2.default;
            } else if (this.isDineIn()) {
                return _dinein_new2.default;
            } else {
                // default image for pickup order
                return _takeAway2.default;
            }
        }
    }, {
        key: 'isDelivery',
        value: function isDelivery() {
            return this.state.orderType == Constants.DELIVERY;
        }
    }, {
        key: 'isPickup',
        value: function isPickup() {
            return this.state.orderType == Constants.PICKUP;
        }
    }, {
        key: 'isDineIn',
        value: function isDineIn() {
            return this.state.orderType == Constants.DINEIN;
        }
    }, {
        key: 'getOrderDetailStructure',
        value: function getOrderDetailStructure() {
            var component = null;

            if (this.isDelivery()) {
                if (!Utils.isEmptyObj(_CartStore2.default.getDeliveryAddress())) {
                    var deliveryAddressObj = this.state.deliveryAddress;
                    component = _react2.default.createElement(
                        'div',
                        { className: 'border-top' },
                        _react2.default.createElement(
                            'p',
                            { className: 'order-detail-delivery text-dark ft-14 mb-1' },
                            _react2.default.createElement(
                                'b',
                                null,
                                'Deliver To: '
                            ),
                            ' ',
                            Constants.getDeliveryAddressStr(deliveryAddressObj),
                            ' '
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: ' color-styl mb-0' },
                            'Based on the address delivery fee is: ',
                            _react2.default.createElement(
                                'b',
                                null,
                                ' $',
                                _CartStore2.default.getDeliveryFeeRounded(2),
                                ' '
                            )
                        )
                    );
                }
                return component;
            } else if (this.isPickup() && this.state.isPreferCurbside) {
                component = _react2.default.createElement(
                    'div',
                    { className: 'border-top' },
                    _react2.default.createElement(
                        'p',
                        { className: 'order-detail-loc mb-0 text-dark ft-14 ' },
                        _react2.default.createElement(
                            'b',
                            null,
                            'Vehicle Details: '
                        ),
                        ' ',
                        _CartStore2.default.getOrderVehicleColor(),
                        ", ",
                        _CartStore2.default.getOrderVehicleMakeModel()
                    )
                );

                return component;
            } else if (this.isDineIn() && !Utils.isEmpty(this.state.slData)) {
                component = _react2.default.createElement(
                    'div',
                    { className: 'border-top' },
                    _react2.default.createElement(
                        'p',
                        { className: 'order-detail-loc text-dark ft-14 mb-0' },
                        _react2.default.createElement(
                            'b',
                            null,
                            this.state.serviceLocation,
                            ':'
                        ),
                        ' ',
                        this.state.slData,
                        ' '
                    )
                );

                return component;
            } else {
                return null;
            }
        }
    }, {
        key: 'getOrderTypeTitle',
        value: function getOrderTypeTitle() {

            var orderType = "";
            if (this.isDelivery()) {
                orderType = "Delivery";
            } else if (this.isDineIn()) {
                orderType = "Dine In";
            } else if (this.isPickup() && this.state.isPreferCurbside) {
                orderType = "Curbside PickUp";
            } else {
                orderType = "Pick Up";
            }
            return orderType;
        }
    }, {
        key: 'redirectToMainPage',
        value: function redirectToMainPage() {
            var locId = this.props.params.locId;
            var history = this.props.history;
            // Navigate to Another Component
            // history.push("/location/" + locId);

            history.push({
                pathname: "/location/" + locId,
                resetStore: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                { className: 'bg-white rounded shadow-sm p-4 mb-3' },
                _react2.default.createElement(
                    'div',
                    { className: 'border-bottom' },
                    _react2.default.createElement(
                        'h4',
                        { className: 'mb-2 d-inline-block font-weight-bold' },
                        'Checkout'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: "d-inline-block pull-right" },
                        _react2.default.createElement(_SpinButton2.default, {
                            classNames: 'btn btn-sm rounded-sm btn-styl font-weight-bold',
                            buttonText: 'Back to Menu',
                            spinText: "Loading...",
                            showSpinner: false,
                            whenClicked: this.redirectToMainPage,
                            showIcon: true,
                            iconClass: "icofont-circled-left fr-10 mr-1",
                            tabIndex: 6
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'delivery-address-section border-bottom' },
                    _react2.default.createElement(
                        'div',
                        { className: 'd-flex flex-column' },
                        _react2.default.createElement(
                            'h6',
                            { className: 'mt-3 mb-1 text-black' },
                            !Utils.isEmptyObj(this.state.location) ? this.state.location.name : ""
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: "mb-2 text-gray" },
                            _react2.default.createElement(
                                'p',
                                { className: 'location-card-ico mb-1' },
                                _react2.default.createElement('i', { className: 'fa fa-map-marker mr-1' })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'location-card-titlepx-1 mb-1' },
                                Constants.getDeliveryAddressStr(this.state.location)
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'Container-location-info' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container-loc-info' },
                        _react2.default.createElement(
                            'div',
                            { className: 'LegendItem' },
                            _react2.default.createElement(
                                'div',
                                { className: 'LegendItem_Eye ' },
                                _react2.default.createElement('img', { className: 'LegendItem_Eye_Img_Add', src: this.loadImage(), alt: '' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ml-40 font-bold' },
                                this.getOrderTypeTitle()
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: '' },
                                _react2.default.createElement(
                                    'a',
                                    {
                                        className: 'address-change-label new-loc-changed-add f16-default color-styl',
                                        href: "#",
                                        onClick: function onClick(e) {
                                            return _this3.handleChange(e);
                                        },
                                        style: { cursor: 'pointer' },
                                        tabIndex: 7
                                    },
                                    _react2.default.createElement('i', { className: 'fa fa-chevron-right icon-color-arrow' }),
                                    _react2.default.createElement(
                                        'u',
                                        null,
                                        'Change'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'LegendItem Legend_text_add' },
                            _react2.default.createElement(
                                'div',
                                { className: 'LegendItem_Eye Legend_text_add' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'schedule-container-loc-cart' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'delivery-type-default ml-5' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'loc_Schedule_datetime text-secondary-light ft-14' },
                                            this.getScheduleOrderDateTime()
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    this.getOrderDetailStructure()
                )
            );
        }
    }]);

    return CartLocationDetail;
}(_react2.default.Component);

//create highter order component.


var LOC_DETAIL_NAVIGATION = withLocationDetailReactRouter(CartLocationDetail);
exports.default = LOC_DETAIL_NAVIGATION;


//////////////////
// WEBPACK FOOTER
// ./src/components/cart-view/cart-left/CartLocationDetail.jsx
// module id = 568
// module chunks = 0